import warningIcon from "$assets/icons/warning-icon.svg?url";
import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import { styled, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";

type Icon = "warning";

const iconMap: Record<Icon, { src: string; alt: string }> = {
  warning: { src: warningIcon, alt: "warning" },
};

const Footer = styled(DialogFooter)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[300]}`,
}));

export const TwoButtonModal: FCwC<
  {
    icon: Icon;
    title: JSX.Element | React.ReactNode;
    primaryButtonText?: string;
    onPrimaryButtonClicked: () => void;
    secondaryButtonText?: string;
    onSecondaryButtonClicked: () => void;
  } & React.ComponentProps<typeof DialogContainer>
> = ({
  icon,
  title,
  primaryButtonText,
  onPrimaryButtonClicked,
  onSecondaryButtonClicked,
  secondaryButtonText,
  children,
  ...delegateProps
}) => {
  const iconProps = iconMap[icon];
  return (
    <DialogContainer {...delegateProps}>
      <DialogHeader title="">
        <img {...iconProps} />
        <Typography variant="h5">{title}</Typography>
      </DialogHeader>
      <DialogBody>{children}</DialogBody>
      <Footer>
        <Button
          color="secondary"
          onClick={onSecondaryButtonClicked}
          data-testid="components.twoButtonModal.cancel"
        >
          {secondaryButtonText || (
            <FormattedMessage
              id="components.twoButtonModal.cancel"
              defaultMessage="Cancel"
            />
          )}
        </Button>
        <Button
          onClick={onPrimaryButtonClicked}
          data-testid="components.twoButtonModal.accept"
        >
          {primaryButtonText || (
            <FormattedMessage
              id="components.twoButtonModal.accept"
              defaultMessage="Accept"
            />
          )}
        </Button>
      </Footer>
    </DialogContainer>
  );
};

export default TwoButtonModal;
